<template>
  <div
    v-if="visible"
    class="snack-bar snckbr"
  >
    <slot />
    <div
      v-if="canClose"
      class="snckbr_close mdi mdi-close icon_btn csst csst"
      @click="close"
    >
      <div
        class="csst_content text-nowrap capitalize"
        style="left: -0.25rem; transform: translate(-100%, 0)"
      >
        {{ oneTimeOnly ? $t('common.close_forever') : $t('tooltips.close') }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Snackbar',
  props: {
    oneTimeOnly: Boolean,
    localKey: String,
    canClose: { type: Boolean, default: true },
  },
  data() {
    return {
      visible: false,
    }
  },
  created() {
    this.visible = this.oneTimeOnly ? localStorage.getItem(this.localKey) !== 'closed' : true
  },
  methods: {
    close() {
      if (this.localKey) {
        localStorage.setItem(this.localKey, 'closed')
      }
      this.visible = false
    },
  },
}
</script>

<style lang="scss">
.snckbr {
  --clr-back: var(--clr-black-2);
  --position: fixed;
  --close-inset: 0.25rem 0.25rem auto auto;
  --close-padding: 0.5rem;
  --close-size: 1.25rem;
  --left: 50%;
  --bottom: calc(var(--safe-area-inset-bottom) + 3rem);
  background: var(--clr-back);
  z-index: 4;
  padding: 1rem 1.5rem;
  border-radius: 4px;
  position: var(--position);
  &_close {
    position: absolute !important;
    font-size: var(--close-size);
    inset: var(--close-inset);
    padding: var(--close-padding);
    z-index: 4;
  }
  &_bottom-right {
    right: 1rem;
    bottom: 1rem;
  }
  &_bottom-center {
    left: var(--left);
    transform: translate(-50%, 0);
    max-width: calc(100vw - 2rem);
    bottom: var(--bottom);
    box-shadow: var(--menu-shadow);
    animation: slideBottom 1.2s;
    transition: 0.22s;
  }
  &_top-full {
    top: 0;
    left: 50%;
    transform: translate(-50%, 0);
  }
}

@keyframes slideBottom {
  0% {
    opacity: 0;
    bottom: -4rem;
  }
  60% {
    opacity: 0;
    bottom: -4rem;
  }
  90% {
    opacity: 1;
    bottom: calc(var(--bottom) + 0.5rem);
  }
  100% {
    opacity: 1;
    bottom: var(--bottom);
  }
}

@media screen and (max-width: 1023px) {
  .snckbr {
    --left: 50% !important;
    // --bottom: 4rem !important;
  }
}
</style>
